"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TabelaCabecalhoCelula = void 0;
var react_1 = __importDefault(require("react"));
var styles = require('./TabelaCabecalhoCelula.module.scss');
var Icone_1 = require("../../Icone/Icone");
var Cores_1 = require("../../Cores/Cores");
var OrdenacaoDirecao_1 = require("../../../enums/OrdenacaoDirecao");
var TabelaCabecalhoCelula = function (_a) {
    var children = _a.children, style = _a.style, ordenavel = _a.ordenavel, onOrdenar = _a.onOrdenar, direcaoAtualOrdenacao = _a.direcaoAtualOrdenacao;
    return (react_1.default.createElement("th", { className: styles.headerCell, style: style, onClick: ordenavel ? onOrdenar : undefined },
        react_1.default.createElement("div", { className: styles.columnCell },
            react_1.default.createElement("div", { className: styles.columnTitle }, children),
            ordenavel && (react_1.default.createElement("span", { className: styles.sortIcon },
                react_1.default.createElement(Icone_1.Icone, { nome: "filter_list", altura: "18px", largura: "18px", className: direcaoAtualOrdenacao === OrdenacaoDirecao_1.OrdenacaoDirecao.DESC ? styles.rotatedIcon : undefined, cor: (direcaoAtualOrdenacao === OrdenacaoDirecao_1.OrdenacaoDirecao.DESC || direcaoAtualOrdenacao === OrdenacaoDirecao_1.OrdenacaoDirecao.ASC) ?
                        Cores_1.Cores.CoresIdentidadeMU.azulMu : Cores_1.Cores.CoresIdentidadeMU.cinzaMu }))))));
};
exports.TabelaCabecalhoCelula = TabelaCabecalhoCelula;
